/* Kollektionsseite des Weissblau-Themes: Filterpanel, Spaltenwahl, Sortierung, Nachladen.
 *
 * Grundsatz: alles funktioniert auch ohne dieses Skript.
 * - Die Filterleiste ist ein <form method="get">. Ohne JavaScript sendet "Anzeigen" ab.
 * - "Mehr anzeigen" ist ein echter Link auf ?page=2. Ohne JavaScript ist es die naechste Seite -
 *   und Google kommt ueber ihn an alle Produkte (docs/relaunch/01 Abschnitt 3.1).
 * Das Skript macht daraus ein Panel, ein Nachladen und ein Filtern ohne Neuladen.
 *
 * Nachgeladen wird ueber die Section Rendering API (?section_id=...). Es kommt genau diese eine
 * Section zurueck, nicht die ganze Seite.
 *
 * Aus docs/relaunch/08:
 * - Veraltete Antworten: jede Anfrage bekommt eine Nummer, nur die neueste wird eingesetzt (D2).
 * - Keine Geometrie im Scroll-Handler (E11). Hier wird ueberhaupt nicht gescrollt gehorcht - das Nachladen haengt an
 *   zwei IntersectionObservern und setzt nur ein, solange das Listenende unter dem Bildschirm liegt (E11, CLS).
 * - Overlays liegen ueber dem Shopify-Chat (C6) - das macht das CSS.
 */
(() => {
  'use strict';

  const SPEICHER = 'mhsys-spalten';
  /* So viele Bildschirmhoehen vor dem Listenende wird die naechste Seite geholt (Nachladen, mehrVerbinden()) */
  const VORLAUF = 2.5;
  /* Zurueck ohne Back-Forward-Cache (Roadmap 3.80): was beim Verlassen geladen war, in sessionStorage */
  const ZURUECK = 'mhsys-koll-zurueck';
  /* Hoechstens so viele Seiten gleichzeitig nachholen - Shopify drosselte viele Abrufe mit 429 (02.10.2026) */
  const ZURUECK_PARALLEL = 2;

  /* Die Seitenzahl aus ?page=N (ohne: 1) */
  const seiteAus = (suche) => Math.max(1, parseInt(new URLSearchParams(suche).get('page'), 10) || 1);

  let aktiv = null; /* die Instanz mit Raster - an sie haengt pagehide den Stand */
  let zurueckGeprueft = false; /* nur die erste Instanz nach dem Laden holt nach, nicht die nach einem Filter */
  let geklickt = null; /* { handle, oben } - die zuletzt angeklickte Kachel */

  class MhsysKollektion {
    constructor(wurzel) {
      this.wurzel = wurzel;
      this.sectionId = wurzel.dataset.mhsysSection;
      this.formular = wurzel.querySelector('[data-mhsys-filterform]');
      this.raster = wurzel.querySelector('[data-mhsys-koll-raster]');
      this.lauf = 0;
      /* Ab dieser Seite steht die Liste (ueber Google kommt man auch auf ?page=3) - davor fehlt nichts */
      this.startSeite = seiteAus(window.location.search);
      if (this.raster) aktiv = this;

      this.spaltenVerbinden();
      this.panelVerbinden();
      this.filterVerbinden();
      this.mehrVerbinden();
      this.stimmeVerbinden();
      this.budgetZaehlen();
      if (!zurueckGeprueft) {
        zurueckGeprueft = true;
        this.zurueckHolen();
      }
    }

    /* ---------------------------------------------------- Budget-Knoepfe
       Liquid kennt nur den teuersten Artikel, nicht die leeren Stufen darunter (snippets/mhsys-filterleiste.liquid).
       Je Knopf eine Abfrage der Trefferzahl ueber sections/mhsys-budget-zahl.liquid (~120 Byte), erst im Leerlauf;
       je Adresse einmal je Sitzung. Leere Stufen werden ausgegraut, nicht entfernt - es springt nichts. */
    budgetZaehlen() {
      const knoepfe = Array.from(this.wurzel.querySelectorAll('[data-mhsys-budget]'));
      if (!knoepfe.length) return;
      const los = () => {
        knoepfe.forEach((knopf) => {
          const ziel = knopf.getAttribute('href');
          const schluessel = `mhsys-budget:${ziel}`;
          let gemerkt = null;
          try {
            gemerkt = window.sessionStorage.getItem(schluessel);
          } catch (e) {
            /* ohne Speicher eben neu fragen */
          }
          if (gemerkt !== null) {
            this.budgetSetzen(knopf, Number(gemerkt));
            return;
          }
          const getrennt = ziel.indexOf('?') >= 0 ? '&' : '?';
          fetch(`${ziel}${getrennt}section_id=mhsys-budget-zahl`)
            .then((r) => (r.ok ? r.text() : ''))
            .then((html) => {
              const treffer = /data-mhsys-budget-zahl="(\d+)"/.exec(html);
              if (!treffer) return;
              try {
                window.sessionStorage.setItem(schluessel, treffer[1]);
              } catch (e) {
                /* nichts */
              }
              this.budgetSetzen(knopf, Number(treffer[1]));
            })
            .catch(() => {
              /* ohne Zahl bleibt der Knopf einfach aktiv */
            });
        });
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(los, { timeout: 2000 });
      else window.setTimeout(los, 300);
    }

    budgetSetzen(knopf, zahl) {
      if (zahl > 0 || !knopf.isConnected) return;
      knopf.classList.add('is-leer');
      knopf.setAttribute('aria-disabled', 'true');
      knopf.setAttribute('tabindex', '-1');
    }

    /* ---------------------------------------------------- Kachel "Kunden sagen"
       Roadmap 3.114: bis zu sechs Zitate stehen im HTML (snippets/mhsys-stimme-kachel.liquid), sichtbar ist ohne
       Skript das erste. Hier: ein zufaelliges zeigen und die Punkte zum Weiterblaettern einblenden - kein
       Selbstlauf, die Kachel soll nicht um Aufmerksamkeit zappeln. */
    stimmeVerbinden() {
      const kachel = this.wurzel.querySelector('[data-mhsys-stimme]');
      if (!kachel) return;
      const eintraege = [...kachel.querySelectorAll('[data-mhsys-stimme-eintrag]')];
      const punkte = [...kachel.querySelectorAll('[data-mhsys-stimme-punkt]')];
      const zeigen = (nr) => {
        eintraege.forEach((e, i) => (e.hidden = i !== nr));
        punkte.forEach((p, i) => (i === nr ? p.setAttribute('aria-current', 'true') : p.removeAttribute('aria-current')));
      };
      if (eintraege.length < 2) return;
      zeigen(Math.floor(Math.random() * eintraege.length));
      const leiste = kachel.querySelector('[data-mhsys-stimme-punkte]');
      if (leiste) leiste.hidden = false;
      punkte.forEach((p) => p.addEventListener('click', () => zeigen(Number(p.dataset.mhsysStimmePunkt) || 0)));
    }

    /* ---------------------------------------------------------- Spaltenwahl */
    spaltenVerbinden() {
      const knoepfe = [...this.wurzel.querySelectorAll('[data-mhsys-spalten]')];
      if (!knoepfe.length) return;

      /* Gemerkte Wahl wiederherstellen. Der Zugriff kann werfen (privates Fenster,
         blockierte Seitendaten), deshalb in try/catch. */
      let gemerkt = null;
      try {
        gemerkt = window.localStorage.getItem(SPEICHER);
      } catch (e) {
        gemerkt = null;
      }
      if (gemerkt && knoepfe.some((k) => k.dataset.mhsysSpalten === gemerkt)) {
        this.spaltenSetzen(gemerkt, knoepfe);
      }

      knoepfe.forEach((knopf) => {
        knopf.addEventListener('click', () => {
          const zahl = knopf.dataset.mhsysSpalten;
          this.spaltenSetzen(zahl, knoepfe);
          try {
            window.localStorage.setItem(SPEICHER, zahl);
          } catch (e) {
            /* ohne Speicher gilt die Wahl eben nur fuer diese Seite */
          }
        });
      });
    }

    spaltenSetzen(zahl, knoepfe) {
      this.wurzel.style.setProperty('--mhsys-spalten', zahl);
      knoepfe.forEach((k) => {
        const aktiv = k.dataset.mhsysSpalten === zahl;
        k.classList.toggle('is-aktiv', aktiv);
        k.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      });
    }

    /* ------------------------------------------------------------- Panel */
    panelVerbinden() {
      this.panel = this.wurzel.querySelector('[data-mhsys-filter]');
      if (!this.panel) return;

      /* Erst jetzt wird aus dem Block ein Overlay. Im Markup steht er offen, damit die Filter
         auch ohne dieses Skript erreichbar sind. Ein Inline-Skript in mhsys-kollektion.liquid macht
         diese zwei Zeilen schon synchron beim Parsen (Roadmap 2.6) - hier bleiben sie als Fallback
         (falls das Panel nachgeladen wird) und weil ein zweites Setzen nichts kostet. */
      this.panel.classList.add('mhsys-filter--overlay');
      this.panel.hidden = true;

      this.wurzel.querySelectorAll('[data-mhsys-filter-auf]').forEach((k) => {
        k.hidden = false;
        k.addEventListener('click', () => this.panelAuf());
      });
      this.panel.querySelectorAll('[data-mhsys-filter-zu]').forEach((k) =>
        k.addEventListener('click', () => this.panelZu())
      );
      this.panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.panelZu();
      });
    }

    /* aria-expanded an jedem Filter-Knopf (es kann nach dem Nachladen ein neuer sein) */
    knopfZustand(offen) {
      document.querySelectorAll('[data-mhsys-filter-auf]').forEach((k) => {
        k.setAttribute('aria-expanded', offen ? 'true' : 'false');
      });
    }

    panelAuf() {
      if (!this.panel) return;
      this.zuletztAktiv = document.activeElement;
      this.panel.hidden = false;
      this.knopfZustand(true);
      document.documentElement.classList.add('mhsys-overlay-offen');
      const kasten = this.panel.querySelector('.mhsys-filter__panel');
      if (kasten) kasten.focus();
    }

    /* Fokus zurueck auf "Filter". document.activeElement war beim Oeffnen nicht immer der Knopf
       (Safari fokussiert Knoepfe beim Klick nicht, nach dem Nachladen ist er ein neues Element) -
       der Fokus landete nach Esc auf body (Funktionstest 18.09.2026). */
    panelZu() {
      if (!this.panel || this.panel.hidden) return;
      this.panel.hidden = true;
      this.knopfZustand(false);
      document.documentElement.classList.remove('mhsys-overlay-offen');
      let ziel = this.zuletztAktiv;
      if (!ziel || !ziel.isConnected || ziel === document.body || !ziel.matches('[data-mhsys-filter-auf]')) {
        ziel = document.querySelector('[data-mhsys-filter-auf]:not([hidden])') || ziel;
      }
      if (ziel && ziel.focus) ziel.focus();
    }

    /* -------------------------------------------------------- Filtern */
    filterVerbinden() {
      if (!this.formular) return;

      /* Absenden abfangen und stattdessen nachladen */
      this.formular.addEventListener('submit', (e) => {
        e.preventDefault();
        this.nachladen(this.zielUrl());
        this.panelZu();
      });

      /* Sortierung wirkt sofort */
      const sort = this.formular.querySelector('[data-mhsys-sort]');
      if (sort) {
        sort.addEventListener('change', () => this.nachladen(this.zielUrl()));
      }

      /* Ein Häkchen aktualisiert nur die Trefferzahl im Knopf "Anzeigen", nicht die Seite:
         wer drei Filter setzt, will nicht drei Neuladungen. */
      this.formular.addEventListener('change', (e) => {
        if (e.target.type === 'checkbox') this.vorschauZaehlen();
      });

      /* Chips, "alle entfernen" und die Budget-Knoepfe sind Links - auch die ohne Neuladen */
      this.wurzel.addEventListener('click', (e) => {
        const chip = e.target.closest('.mhsys-chip, .mhsys-koll__alleweg, .mhsys-filter__zuruecksetzen, .mhsys-koll__budgetknopf');
        if (!chip) return;
        e.preventDefault();
        if (chip.classList.contains('is-leer')) return;
        this.nachladen(chip.getAttribute('href'));
        this.panelZu();
      });
    }

    zielUrl() {
      const daten = new FormData(this.formular);
      const teile = new URLSearchParams();
      for (const [name, wert] of daten.entries()) {
        if (String(wert).trim() !== '') teile.append(name, wert);
      }
      const basis = this.formular.getAttribute('action') || window.location.pathname;
      const abfrage = teile.toString();
      return abfrage ? `${basis}?${abfrage}` : basis;
    }

    /* Trefferzahl im Knopf "Anzeigen" nachziehen, ohne die Seite zu tauschen */
    vorschauZaehlen() {
      const knopf = this.formular.querySelector('[data-mhsys-filter-anwenden]');
      if (!knopf) return;
      const nummer = ++this.lauf;
      knopf.classList.add('is-laedt');
      this.holen(this.zielUrl())
        .then((doc) => {
          if (nummer !== this.lauf || !doc) return;
          const neu = doc.querySelector('[data-mhsys-filter-anwenden]');
          if (neu) knopf.textContent = neu.textContent.trim();
        })
        .finally(() => {
          if (nummer === this.lauf) knopf.classList.remove('is-laedt');
        });
    }

    /* Ganze Section tauschen und die Adresszeile mitfuehren */
    nachladen(url) {
      if (!url) return;
      const nummer = ++this.lauf;
      this.wurzel.classList.add('is-laedt');
      this.holen(url)
        .then((doc) => {
          if (nummer !== this.lauf || !doc) return;
          const neu = doc.querySelector('[data-mhsys-kollektion]');
          if (!neu) return;
          this.wurzel.replaceWith(document.adoptNode(neu));
          /* Die Adresszeile muss mitziehen: sonst fuehrt Neuladen oder Teilen auf die
             ungefilterte Seite. */
          window.history.replaceState({}, '', url);
          const frisch = new MhsysKollektion(neu);
          void frisch;
          /* Nach Filter, Chip oder Sortierung den Anfang der Treffer zeigen: wird die Liste kuerzer,
             stand man sonst unter dem Raster (im Seitenfuss) und sah nicht, dass sich etwas getan hat.
             Nur wenn die Werkzeugleiste nicht ohnehin oben im Bild ist; der klebende Kopf zaehlt mit, ebenso eine
             klebende Sprungleiste darunter (sections/mhsys-unternavi.liquid, z. B. auf der Weihnachtsseite). */
          const sprungleiste = document.querySelector('.mhsys-unternavi-abschnitt');
          const kopfHoehe = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mhsys-kopf-hoehe')) || 0)
            + (sprungleiste ? sprungleiste.offsetHeight : 0);
          const oben = neu.getBoundingClientRect().top;
          if (oben < kopfHoehe || oben > window.innerHeight * 0.6) {
            window.scrollTo({ top: Math.max(0, window.scrollY + oben - kopfHoehe - 8) });
          }
        })
        .finally(() => {
          this.wurzel.classList.remove('is-laedt');
        });
    }

    /* --------------------------------------------------------- Nachladen */
    mehrVerbinden() {
      const link = this.wurzel.querySelector('[data-mhsys-mehr]');
      if (!link || !this.raster) return;
      this.link = link;

      /* Die naechste Seite kommt von selbst - aber nur, solange das Listenende unter dem Bildschirm liegt.
         Eingesetzte Kacheln schieben alles darunter (Mehr-Link, Seitenzahlen, SEO-Text, FAQ, Bewertungen); steht das
         nicht im Bild, verschiebt sich nichts Sichtbares, und Google zaehlt keine Layoutverschiebung. Bis 30.09.2026
         wurde eingesetzt, wenn der Link 800 px vor Sicht kam - oft erst, als Inhalt darunter schon im Bild stand:
         CLS 0,46 (Kinder, Desktop), 0,08 (Einstieg, Handy). Vom 30.09. bis 02.10.2026 deshalb nur noch auf Tippen -
         den Knopf uebersahen Kunden und glaubten, es gebe nicht mehr Produkte (Inhaber 02.10.2026).
         Jetzt: holen, sobald das Ende VORLAUF Bildschirmhoehen entfernt ist, und einsetzen, sobald die Antwort da ist
         und das Ende noch unter dem Bildschirm liegt. Ist man schneller am Ende als die Antwort, bleibt "Mehr anzeigen"
         stehen (fertig geholt, setzt beim Tippen ohne Wartezeit ein) und die Seite kommt von selbst, sobald das Ende
         wieder unter dem Bildschirm liegt. */
      this.vorrat = null; /* { ziel, antwort, fertig } - die vorab geholte naechste Seite */
      this.fehlgeschlagen = null; /* Ziel, dessen Abruf leer kam - nicht von selbst wiederholen */

      link.addEventListener('click', (e) => {
        e.preventDefault();
        /* Per Tastatur ausgeloest (der Link hat den Fokus): danach auf die erste neue Kachel springen,
           sonst bliebe der Fokus am Link hinter allen neuen Artikeln bzw. ginge mit ihm verloren (h10) */
        this.anhaengen(document.activeElement === link);
      });

      /* Zwei Beobachter am Link, der ein echter Link auf ?page=N bleibt (fuer Google und ohne Skript; docs/relaunch/03
         Abschnitt 27, 04 Abschnitt 10): einer mit grossem Vorlauf (holen), einer am Bildschirmrand (meldet, wenn das
         Ende wieder unter den Bildschirm rutscht - dann darf eine wartende Seite hinein). Kein Scroll-Horcher. */
      if ('IntersectionObserver' in window) {
        this.beobachter = [
          new IntersectionObserver(() => this.pruefen(), { rootMargin: `0px 0px ${VORLAUF * 100}% 0px` }),
          new IntersectionObserver(() => this.pruefen()),
        ];
        this.beobachter.forEach((b) => b.observe(link));
      }
    }

    /* Holen, sobald das Ende nah ist; einsetzen, sobald es da ist und nichts Sichtbares darunter schiebt */
    pruefen() {
      const link = this.link;
      if (!link || !link.isConnected) {
        if (this.beobachter) this.beobachter.forEach((b) => b.disconnect());
        return;
      }
      if (link.classList.contains('is-laedt')) return;
      const oben = link.getBoundingClientRect().top;
      const bild = window.innerHeight;
      if (oben > bild * (1 + VORLAUF)) return;
      this.vorladen(link);
      if (!this.vorrat || !this.vorrat.fertig) return; /* kommt noch - vorladen() ruft pruefen() wieder */
      if (oben < bild) return; /* Ende im Bild: einsetzen wuerde verschieben - "Mehr anzeigen" bleibt stehen */
      /* Nicht waehrend eines Sprungs der Sprungleiste (html[data-mhsys-springt], sections/mhsys-unternavi.liquid):
         wer ueber das Raster hinweg zu einem Abschnitt darunter springt, will dort ankommen (28.09.2026: CLS 0,45) */
      if (document.documentElement.hasAttribute('data-mhsys-springt')) return;
      this.anhaengen(false);
    }

    /* Naechste Seite schon holen, aber nicht einsetzen - hoechstens eine Anfrage je Ziel */
    vorladen(link) {
      const ziel = link.getAttribute('href');
      if (!ziel || ziel === this.fehlgeschlagen || (this.vorrat && this.vorrat.ziel === ziel)) return;
      const vorrat = { ziel, antwort: this.holen(ziel), fertig: false };
      this.vorrat = vorrat;
      vorrat.antwort.then(() => {
        vorrat.fertig = true;
        if (this.vorrat === vorrat) this.pruefen();
      });
    }

    /* Die naechste Seite unter die Liste haengen - per Tippen oder von selbst aus pruefen() */
    anhaengen(perTastatur) {
      const link = this.link;
      const ziel = link.getAttribute('href');
      if (!ziel || link.classList.contains('is-laedt')) return;
      link.classList.add('is-laedt');
      link.setAttribute('aria-busy', 'true');
      /* Vorab geholt: diese Antwort nehmen (kam sie leer an, doch noch einmal holen) */
      const vorrat = this.vorrat && this.vorrat.ziel === ziel ? this.vorrat.antwort : null;
      this.vorrat = null;

      (vorrat ? vorrat.then((doc) => doc || this.holen(ziel)) : this.holen(ziel))
          .then((doc) => {
            if (!doc) {
              this.fehlgeschlagen = ziel;
              return;
            }
            const neuesRaster = doc.querySelector('[data-mhsys-koll-raster]');
            let ersteNeue = null;
            if (neuesRaster) {
              /* Anhaengen statt tauschen - was schon da ist, bleibt stehen. Die erste Reihe einer Folgeseite kommt mit
                 eager und Vorrang (fuer den Aufruf von ?page=N, Roadmap 1.127) - angehaengt steht sie unter dem
                 Bildschirm und laedt wie der Rest erst beim Scrollen */
              neuesRaster.querySelectorAll('img[loading="eager"], img[fetchpriority]').forEach((bild) => {
                bild.loading = 'lazy';
                bild.removeAttribute('fetchpriority');
              });
              while (neuesRaster.firstElementChild) {
                const kachel = this.raster.appendChild(document.adoptNode(neuesRaster.firstElementChild));
                if (!ersteNeue) ersteNeue = kachel;
              }
            }
            if (perTastatur && ersteNeue) {
              const fokusZiel = ersteNeue.querySelector('.mhsys-kachel__name a, a[href]');
              if (fokusZiel) fokusZiel.focus();
            }
            const neuerLink = doc.querySelector('[data-mhsys-mehr]');
            if (neuerLink) {
              link.setAttribute('href', neuerLink.getAttribute('href'));
            } else {
              const huelle = link.closest('.mhsys-koll__mehr');
              if (huelle) huelle.remove();
            }
            /* Seitenzahlen mitziehen, sonst bliebe nach dem Anhaengen "1" markiert */
            const neueSeiten = doc.querySelector('.mhsys-koll__seiten');
            const alteSeiten = this.wurzel.querySelector('.mhsys-koll__seiten');
            if (neueSeiten && alteSeiten) alteSeiten.replaceWith(document.adoptNode(neueSeiten));
            window.history.replaceState({}, '', ziel);
          })
          .finally(() => {
            link.classList.remove('is-laedt');
            link.removeAttribute('aria-busy');
            /* Steht der Link nach dem Anhaengen noch im Vorlauf, meldet der Observer keinen neuen Wechsel -
               dann gleich die naechste Seite holen (und einsetzen, solange das Ende unter dem Bildschirm liegt) */
            if (this.beobachter) this.pruefen();
          });
    }

    /* ------------------------------------------- Zurueck ohne Back-Forward-Cache (Roadmap 3.80) */
    /* Das Nachladen fuehrt die Adresse auf ?page=N mit. Wer von einer Kachel zurueckkommt und den Back-Forward-Cache
       nicht hat (manche eingebauten Browser, z. B. Instagram), bekam vom Server nur Seite N - und der Browser stellte
       den alten Scrollstand wieder her: Fietes Korbtest 02.10.2026, Kinder 375, 8.152 px, man landete in den
       Kundenfragen, die angeklickte Kachel fehlte. Deshalb merkt sich pagehide den Stand (dort auch
       scrollRestoration = 'manual' fuer diesen Eintrag), und hier werden die Seiten davor nachgeholt, vor Seite N
       gesetzt und zur angeklickten Kachel gescrollt. Eingesetzt wird bei unsichtbarem Raster: verschobene, nicht
       gezeichnete Kacheln zaehlen nicht als Layoutverschiebung; das Scrollen danach ist keine. */
    zurueckHolen() {
      let eintrag = null;
      try {
        eintrag = JSON.parse(window.sessionStorage.getItem(ZURUECK) || 'null');
        window.sessionStorage.removeItem(ZURUECK);
      } catch (e) {
        return;
      }
      const nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
      const passt = eintrag && nav && nav.type === 'back_forward' && this.raster
        && eintrag.pfad === window.location.pathname && eintrag.suche === window.location.search;
      if (!passt) {
        if (eintrag) zurueckAutomatisch();
        return;
      }
      const seiten = [];
      for (let s = Math.max(1, eintrag.von); s < Math.min(eintrag.bis, seiteAus(window.location.search)); s++) seiten.push(s);
      if (!seiten.length) {
        zurueckAutomatisch();
        return;
      }

      const adresse = (seite) => {
        const p = new URLSearchParams(window.location.search);
        p.set('page', String(seite));
        return `${window.location.pathname}?${p.toString()}`;
      };
      const raster = this.raster;
      raster.style.visibility = 'hidden';
      const ergebnisse = new Array(seiten.length);
      let naechste = 0;
      const arbeiter = () => {
        if (naechste >= seiten.length) return Promise.resolve();
        const i = naechste++;
        return this.holen(adresse(seiten[i])).then((doc) => {
          ergebnisse[i] = doc;
          return arbeiter();
        });
      };
      const arbeiterListe = [];
      for (let n = 0; n < Math.min(ZURUECK_PARALLEL, seiten.length); n++) arbeiterListe.push(arbeiter());

      Promise.all(arbeiterListe)
        .then(() => {
          const vorne = document.createDocumentFragment();
          ergebnisse.forEach((doc) => {
            const r = doc && doc.querySelector('[data-mhsys-koll-raster]');
            if (r) while (r.firstElementChild) vorne.appendChild(document.adoptNode(r.firstElementChild));
          });
          raster.insertBefore(vorne, raster.firstElementChild);
          /* Zur angeklickten Kachel - mit demselben Abstand zum oberen Rand wie beim Klick; ohne Kachel der alte
             Scrollstand, der jetzt wieder auf dieselbe Liste passt */
          let ziel = null;
          if (eintrag.handle) {
            const name = window.CSS && CSS.escape ? CSS.escape(eintrag.handle) : eintrag.handle;
            const link = raster.querySelector(`[data-mhsys-verlauf="${name}"]`);
            ziel = link ? link.closest('[data-mhsys-koll-raster] > *') : null;
          }
          const y = ziel
            ? window.scrollY + ziel.getBoundingClientRect().top - (Number.isFinite(eintrag.oben) ? eintrag.oben : 120)
            : eintrag.y;
          window.scrollTo(0, Math.max(0, y || 0));
        })
        .catch((e) => console.error('Kollektion:', e))
        .finally(() => {
          raster.style.visibility = '';
          zurueckAutomatisch();
        });
    }

    /* Genau diese Section holen, nicht die ganze Seite */
    holen(url) {
      const getrennt = url.indexOf('?') >= 0 ? '&' : '?';
      const voll = `${url}${getrennt}section_id=${encodeURIComponent(this.sectionId)}`;
      return fetch(voll)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => (html ? new DOMParser().parseFromString(html, 'text/html') : null))
        .catch((e) => {
          console.error('Kollektion:', e);
          return null;
        });
    }
  }

  /* Scrollstand wieder vom Browser wiederherstellen lassen (gilt fuer den aktuellen Verlaufseintrag) */
  function zurueckAutomatisch() {
    try {
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'auto';
    } catch (e) {
      /* nichts */
    }
  }

  /* Die angeklickte Kachel merken (Capture: vor der Navigation, auch fuer den Plus-Link auf die Produktseite) */
  document.addEventListener(
    'click',
    (e) => {
      const kachel = e.target.closest ? e.target.closest('[data-mhsys-koll-raster] > *') : null;
      if (!kachel || !e.target.closest('a[href]')) return;
      const link = kachel.querySelector('[data-mhsys-verlauf]');
      geklickt = { handle: link ? link.dataset.mhsysVerlauf : '', oben: Math.round(kachel.getBoundingClientRect().top) };
      folgeMerken(kachel.parentElement);
    },
    true
  );

  /* "Weiter in …" auf der Produktseite (Roadmap 1.78, Inhaber 08.10.2026, Idee 7): die geladene Liste in ihrer
     Reihenfolge merken - Handle, Name, Preis, Bild -, damit die Produktseite am Ende den vorigen und den naechsten
     Artikel zeigen kann, ohne Umweg ueber Zurueck. Nur in diesem Tab (sessionStorage), hoechstens 250 Artikel.
     Gelesen von assets/mhsys-produkt.js, weiterInListe(). */
  const FOLGE = 'mhsys-koll-folge';
  function folgeMerken(raster) {
    try {
      const liste = [];
      raster.querySelectorAll(':scope > *').forEach((k) => {
        // Der Name aus dem Titel-Link - der Bildlink davor traegt dasselbe Handle, aber keinen Text
        const a = k.querySelector('.mhsys-kachel__name [data-mhsys-verlauf]') || k.querySelector('[data-mhsys-verlauf]');
        if (!a || liste.length >= 250) return;
        const preis = k.querySelector('.mhsys-kachel__preis');
        const bild = k.querySelector('img');
        liste.push({
          h: a.dataset.mhsysVerlauf,
          t: a.textContent.trim(),
          p: preis ? (preis.firstChild ? preis.firstChild.textContent : preis.textContent).trim() : '',
          b: bild ? bild.currentSrc || bild.src : '',
        });
      });
      const kopf = document.querySelector('.mhsys-kollkopf__titel, .mhsys-suchseite__titel, h1');
      const titel = kopf ? (kopf.firstChild && kopf.firstChild.nodeType === 3 ? kopf.firstChild.textContent : kopf.textContent).trim() : '';
      // Fuer "Zur ganzen Liste" nur, was die Liste ausmacht (Suchbegriff, Sortierung, Filter) - keine utm-, Vorschau-
      // oder Seiten-Parameter (Pruefbericht 08.10.2026: "?pb=0&x=…" stand im Link)
      const behalten = new URLSearchParams();
      new URLSearchParams(window.location.search).forEach((wert, name) => {
        if (/^(q|type|sort_by|filter\..+)$/.test(name)) behalten.append(name, wert);
      });
      const suche = behalten.toString();
      window.sessionStorage.setItem(FOLGE, JSON.stringify({
        pfad: window.location.pathname,
        suche: suche ? '?' + suche : '',
        titel,
        liste,
      }));
    } catch (x) {
      /* ohne sessionStorage (privates Fenster) gibt es eben kein "Weiter in …" */
    }
  }

  /* Beim Verlassen: war mehr geladen als die Seite, mit der die Liste anfing, den Stand merken (Roadmap 3.80) */
  window.addEventListener('pagehide', () => {
    try {
      const k = aktiv;
      const bis = seiteAus(window.location.search);
      if (!k || !k.wurzel.isConnected || bis <= k.startSeite) {
        window.sessionStorage.removeItem(ZURUECK);
        return;
      }
      window.sessionStorage.setItem(ZURUECK, JSON.stringify({
        pfad: window.location.pathname,
        suche: window.location.search,
        von: k.startSeite,
        bis,
        handle: geklickt ? geklickt.handle : '',
        oben: geklickt ? geklickt.oben : null,
        y: Math.round(window.scrollY),
      }));
      if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    } catch (e) {
      /* ohne sessionStorage (privates Fenster) bleibt es beim Verhalten des Browsers */
    }
  });

  /* Aus dem Back-Forward-Cache zurueck: alles steht noch da - nichts nachholen, Browser wieder scrollen lassen */
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    geklickt = null;
    try {
      window.sessionStorage.removeItem(ZURUECK);
    } catch (x) {
      /* nichts */
    }
    zurueckAutomatisch();
  });

  function starten() {
    document.querySelectorAll('[data-mhsys-kollektion]').forEach((el) => {
      if (el.dataset.mhsysBereit) return;
      el.dataset.mhsysBereit = '1';
      new MhsysKollektion(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten);
  else starten();
  document.addEventListener('shopify:section:load', starten);
})();
